function initCollectionSlider() {
  const sliderEl = document.querySelector(".collection-slider");
  if (!sliderEl || typeof Swiper === "undefined") return;
  if (sliderEl.classList.contains("swiper-initialized")) return;
  new Swiper(".collection-slider", {
    slidesPerView: 2,
    spaceBetween: 16,
    loop: true,
    watchOverflow: true,
    rtl: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
      disabledClass: "swiper-button-disabled",
    },
    breakpoints: {
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 4 },
      1280: { slidesPerView: 5 },
    },
  });
}
document.addEventListener("DOMContentLoaded", () => {
  initCollectionSlider();
  const observer = new MutationObserver(() => {
    setTimeout(() => initCollectionSlider(), 100);
  });
  observer.observe(document.body, { childList: true, subtree: true });
});
